import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { fill: "currentColor" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    "clip-rule": "evenodd",
    d: "M10 0H5a5 5 0 0 0 0 10h5V9H5a4 4 0 1 1 0-8h5V0ZM12 0h5a5 5 0 0 1 0 10h-5V9h5a4 4 0 0 0 0-8h-5V0Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M6 4.5h10v1H6z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}